import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../services/utils.service';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { MrsiService } from './service/mrsi.service';

@Component({
  selector: 'app-mrsi',
  templateUrl: './mrsi.component.html',
  styleUrls: ['./mrsi.component.scss']
})
export class MrsiComponent implements OnInit {
  accessRoles: any;
  constructor(public sidePanelService:SidePanelService, public mrsiService:MrsiService, public utility:UtilsService) { 
    
    this.sidePanelService.initSideDrawer('mrsi');
      this.accessRoles = JSON.parse(localStorage.getItem('access'));
  }

  ngOnInit(): void {
  }

}
